const token = localStorage.getItem("accessToken");
const API_BASE_URL = process.env.REACT_APP_BE_BASE_URL;

// Fetch permissions for a specific action and subject
export const FetchPermissions = async (action: string, subject: string) => {
  const response = await fetch(`${API_BASE_URL}/authz/checkPermission`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-type": "application/json",
    },
    body: JSON.stringify({ actionRequest: action, subjectRequest: subject }),
  });
  const data = await response.json();

  return data.sucess;
};

// Fetch and store pages permissions in session storage

export const PagesPermissions = async () => {
  const response = await fetch(`${API_BASE_URL}/authz/pagesCheck`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  const data = await response.json();

  // Store data in session storage
  localStorage.removeItem("permissions");
  localStorage.setItem("permissions", JSON.stringify(data));

  return data;
};

// Get permissions - first check session storage, then fetch if not available
export const getPermissions = async () => {
  const storedPermissions = localStorage.getItem("permissions");

  // If permissions are already in localStorage, return them
  if (storedPermissions) {
    return JSON.parse(storedPermissions);
  }

  // Otherwise, fetch permissions from the API
  const data = await PagesPermissions();
  return data;
};

// Get permissions from function with token
export const getPermissionsByToken = async (tokenPassed: string) => {
  const response = await fetch(`${API_BASE_URL}/authz/pagesCheck`, {
    headers: { Authorization: `Bearer ${tokenPassed}` },
  });

  const data = await response.json();
  console.log("permissions: ", data);

  // Store data in session storage
  localStorage.removeItem("permissions");
  localStorage.setItem("permissions", JSON.stringify(data));

  return data;
};

// ✅ Fetch tobaco permission from backend or localStorage
export const getTobacoPermission = async () => {
  const cached = localStorage.getItem("seeTobaco");
  if (cached !== null) return cached === "true";

  try {
    const response = await fetch(`${API_BASE_URL}/misteryClient/seeTobaco`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!response.ok) throw new Error("Failed to fetch tobaco permission");
    const result = await response.json();

    // Save to localStorage for next time
    localStorage.setItem("seeTobaco", String(result));

    return result;
  } catch (error) {
    console.error("Error fetching tobaco permission:", error);
    return false;
  }
};
